<template>
  <span>
    <template v-if="($store.getters.getPackage != 'premium' || isCoachlab) && value">
      <div class="label label-info" style="padding: 3px 15px;display: inline-block">
        {{ $t('premium') }}
      </div>
    </template>
    <template v-else-if="$store.getters.getPackage == 'premium' && !isCoachlab && value">
      <slot></slot>
    </template>
    <template v-else
      >-</template
    >
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['value'],
  computed: {
    ...mapGetters(['selectedBot', 'isCoachlab'])
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/CustomerItemValue.vue